import { Card } from '@mantine/core';
import { PropsWithChildren } from 'react';
import { useTheme } from 'styled-components';

type CardVariant = 'default' | 'empty';

function AnswerCard(props: PropsWithChildren<{ variant?: CardVariant }>) {
	const theme = useTheme();
	return (
		<Card
			withBorder
			shadow={props.variant === 'empty' ? 'xs' : 'sm'}
			{...props}
			bg={props.variant === 'empty' ? theme.colors.lightBlueLight : theme.colors.white}
		/>
	);
}

export default AnswerCard;
